const SIGNUP_EMAIL = "SIGNUP_EMAIL";
const LOGIN_EMAIL = "LOGIN_EMAIL";
const SIGNUP_PWD = "SIGNUP_PWD";
const LOGIN_PWD = "LOGIN_PWD";

export { SIGNUP_EMAIL, LOGIN_EMAIL, SIGNUP_PWD, LOGIN_PWD };